import { render, staticRenderFns } from "./centerCategory.vue?vue&type=template&id=31c09d31&scoped=true"
import script from "./centerCategory.vue?vue&type=script&lang=js"
export * from "./centerCategory.vue?vue&type=script&lang=js"
import style0 from "./centerCategory.vue?vue&type=style&index=0&id=31c09d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c09d31",
  null
  
)

export default component.exports